import { render, staticRenderFns } from "./PeriodicTable.vue?vue&type=template&id=681c0ff2&scoped=true"
import script from "./PeriodicTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./PeriodicTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PeriodicTable.vue?vue&type=style&index=0&id=681c0ff2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681c0ff2",
  null
  
)

export default component.exports